export function enumerable(value: boolean) {
  return function (target: any, propertyKey: string) {
    Object.defineProperty(target, propertyKey, {
      enumerable: value,
      writable: true,
    });
  };
}

export function areTreesSameByNodeId(tree1: any, tree2: any) {
  const ids1 = Object.keys(tree1.nodes);
  const ids2 = Object.keys(tree2.nodes);
  return (
    ids1.length === ids2.length &&
    ids1.every(id => {
      return ids2.includes(id) && tree1.getNodeById(id).isVirtual === tree2.getNodeById(id).isVirtual;
    })
  );
}
